
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxValidationRule,

} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';

import ListadoDocumentacionService from '../services/listadodocumentacion-service';
import ListadoDocumentacionDetalleService from '../services/grupolistadodocumentaciondetalle-service';
import ResponsabilidadEntregaService from '../services/responsabilidadentrega-service';





export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,
        DxValidationRule
    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {
            dataSourceResponsabilidadEntrega: null,
            procedimientos: null,
            dataSourceServicio: null,
            dataSourceSolicitudServicio: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Listado Documentación',
                showTitle: true,
                width: 600,
                height: 400,
            },



        };
    },
    created() {

        this.listadodocumentaciondetalleService = new ListadoDocumentacionDetalleService();
        this.listadodocumentacionService = new ListadoDocumentacionService();
        this.responsabilidadentregaService = new ResponsabilidadEntregaService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: id
            });
            this.responsabilidadentregaService.getResponsabilidadEntrega().then(data => this.dataSourceResponsabilidadEntrega = data);
            this.listadodocumentacionService.getListadoDocumentacion().then(data => this.dataSourceServicio = data);
            this.listadodocumentaciondetalleService.getGrupoListadoDocumentacionDetalle(myJSON).then(data => this.dataSourceSolicitudServicio = data);
        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });



            this.listadodocumentaciondetalleService.deleteGrupoListadoDocumentacionDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha eliminado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        editRegister(e) {

            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: e.data.id,
                pgrupolistadodocumentacionid: id,
                plistadodocumentacionid: e.data.listadodocumentacionid,
                porden: e.data.orden,
                presponsabilidadentregaid:e.data.responsabilidadentregaid,
            });




            this.listadodocumentaciondetalleService.updateGrupoListadoDocumentacionDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha actualizado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        createRegister(e) {


            let id = this.supplierId;
            let myJSON = JSON.stringify({

                pgrupolistadodocumentacionid: id,
                plistadodocumentacionid: e.data.listadodocumentacionid,
                porden: e.data.orden,
                presponsabilidadentregaid:e.data.responsabilidadentregaid,
            });



            this.listadodocumentaciondetalleService.createGrupoListadoDocumentacionDetalle(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha creado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        onInitNewRow(e) {
            e.data.bactivo = true;
        },
    },
};
